"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMainPropType = exports.PriceInfoPropTypes = exports.PriceInfoDefaultProps = exports.PriceDetailsPropTypes = exports.PriceDetailsDefaultProps = exports.HotelInfoPropTypes = exports.HotelInfoDefaultProps = exports.HotelCardPropTypes = exports.HotelCardDefaultProps = exports.BogoPromoLabelDefaultProps = exports.BogoFomoLabelPropTypes = exports.AmenityPropTypes = exports.AmenityDefaultProps = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var AmenityPropTypes = {
  amenities: _propTypes.default.instanceOf(Array)
};
exports.AmenityPropTypes = AmenityPropTypes;
var AmenityDefaultProps = {
  amenities: []
};
exports.AmenityDefaultProps = AmenityDefaultProps;
var HotelInfoPropTypes = {
  promoTag: _propTypes.default.string,
  freeCancellationText: _propTypes.default.string,
  payLaterText: _propTypes.default.string,
  fomoMessage: _propTypes.default.string,
  amenities: _propTypes.default.instanceOf(Array),
  starRating: _propTypes.default.instanceOf(Object),
  debug: _propTypes.default.instanceOf(Object),
  hotelName: _propTypes.default.string.isRequired,
  location: _propTypes.default.string,
  distance: _propTypes.default.string,
  reviews: _propTypes.default.instanceOf(Object),
  tripAdvisorReviews: _propTypes.default.instanceOf(Object),
  setAmenityFocused: _propTypes.default.func,
  title: _propTypes.default.string,
  theme: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  highlight: _propTypes.default.bool,
  isDoDEnabled: _propTypes.default.bool,
  promoTitle: _propTypes.default.string,
  discountType: _propTypes.default.string,
  lowInventoryAlert: _propTypes.default.string,
  payNowText: _propTypes.default.string
};
exports.HotelInfoPropTypes = HotelInfoPropTypes;
var HotelInfoDefaultProps = {
  promoTag: null,
  freeCancellationText: null,
  fomoMessage: null,
  payLaterText: null,
  amenities: [],
  starRating: null,
  debug: null,
  location: null,
  promoTitle: null,
  discountType: null,
  distance: null,
  reviews: null,
  tripAdvisorReviews: null,
  setAmenityFocused: function setAmenityFocused() {},
  title: null,
  isMobile: false,
  theme: _constant.DEFAULT_THEME,
  highlight: false,
  lowInventoryAlert: null,
  isDoDEnabled: false,
  payNowText: ''
};
exports.HotelInfoDefaultProps = HotelInfoDefaultProps;
var getMainPropType = {
  imageList: _propTypes.default.instanceOf(Array),
  isMobile: _propTypes.default.bool
};
exports.getMainPropType = getMainPropType;
var BogoFomoLabelPropTypes = {
  bogoTag: _propTypes.default.string
};
exports.BogoFomoLabelPropTypes = BogoFomoLabelPropTypes;
var BogoPromoLabelDefaultProps = {
  bogoTag: 'RM9 on Second Night'
};
exports.BogoPromoLabelDefaultProps = BogoPromoLabelDefaultProps;
var HotelCardPropTypes = {
  accessible: _propTypes.default.bool,
  salesTag: _propTypes.default.string,
  bigPointPromo: _propTypes.default.string,
  images: _propTypes.default.instanceOf(Array),
  discountText: _propTypes.default.string,
  discountType: _propTypes.default.string,
  strikeThrough: _propTypes.default.instanceOf(Object),
  price: _propTypes.default.instanceOf(Object).isRequired,
  totalPrice: _propTypes.default.instanceOf(Object).isRequired,
  promoTag: _propTypes.default.string,
  amenities: _propTypes.default.instanceOf(Array),
  promoTitle: _propTypes.default.string,
  starRating: _propTypes.default.instanceOf(Object),
  debug: _propTypes.default.instanceOf(Object),
  hotelName: _propTypes.default.string.isRequired,
  location: _propTypes.default.string,
  distance: _propTypes.default.string,
  reviews: _propTypes.default.instanceOf(Object),
  tripAdvisorReviews: _propTypes.default.shape({
    reviewCountText: _propTypes.default.string,
    ratingImageUrl: _propTypes.default.string,
    rankingString: _propTypes.default.string
  }),
  theme: _propTypes.default.string,
  translations: _propTypes.default.shape({
    amenityTitle: _propTypes.default.string,
    perGuestText: _propTypes.default.string,
    snapPriceText: _propTypes.default.string,
    freeCancellationText: _propTypes.default.string,
    payLaterText: _propTypes.default.string,
    priceText: _propTypes.default.string,
    fomoMessage: _propTypes.default.string
  }),
  facilities: _propTypes.default.arrayOf(_propTypes.default.string),
  isMobile: _propTypes.default.bool,
  heroImage: _propTypes.default.string,
  onLoadImage: _propTypes.default.func,
  isImageCarouselEnabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  highlight: _propTypes.default.bool,
  isDoDEnabled: _propTypes.default.bool,
  locale: _propTypes.default.string,
  fomoLabel: _propTypes.default.string,
  isFomoTimerEnabled: _propTypes.default.bool,
  isCarouselCard: _propTypes.default.string,
  expandCarouselArrowClickableArea: _propTypes.default.bool,
  fomoTime: _propTypes.default.string,
  time: _propTypes.default.string,
  certifiedSuperTitel: _propTypes.default.string,
  gaIdExperimentValue: _propTypes.default.number,
  isComboSavingsTagEnabled: _propTypes.default.bool,
  savingsAmount: _propTypes.default.number,
  selectRoomLabel: _propTypes.default.string,
  withSelectRoom: _propTypes.default.bool,
  handleMouseEnter: _propTypes.default.func,
  handleMouseLeave: _propTypes.default.func,
  baseRate: _propTypes.default.instanceOf(Object).isRequired
};
exports.HotelCardPropTypes = HotelCardPropTypes;
var HotelCardDefaultProps = {
  accessible: true,
  salesTag: null,
  bigPointPromo: null,
  images: [],
  discountText: null,
  discountType: null,
  strikeThrough: null,
  priceText: null,
  perGuestText: null,
  snapPriceText: null,
  promoTag: null,
  amenities: [],
  starRating: null,
  debug: null,
  location: null,
  distance: null,
  reviews: null,
  tripAdvisorReviews: null,
  theme: _constant.DEFAULT_THEME,
  facilities: [],
  isMobile: false,
  heroImage: null,
  onLoadImage: function onLoadImage() {},
  isImageCarouselEnabled: true,
  onClick: function onClick() {},
  handleMouseEnter: function handleMouseEnter() {},
  handleMouseLeave: function handleMouseLeave() {},
  highlight: false,
  isDoDEnabled: false,
  locale: 'en-gb',
  fomoLabel: null,
  expandCarouselArrowClickableArea: false,
  isFomoTimerEnabled: false,
  isCarouselCard: false,
  fomoTime: '',
  time: '',
  certifiedSuperTitel: '',
  gaIdExperimentValue: 1,
  isComboSavingsTagEnabled: false,
  savingsAmount: 0,
  selectRoomLabel: 'Select Room',
  withSelectRoom: false
};
exports.HotelCardDefaultProps = HotelCardDefaultProps;
var PriceInfoPropTypes = {
  discountText: _propTypes.default.string,
  strikeThrough: _propTypes.default.instanceOf(Object),
  price: _propTypes.default.instanceOf(Object).isRequired,
  priceText: _propTypes.default.string,
  perGuestText: _propTypes.default.string,
  snapPriceText: _propTypes.default.string,
  totalPrice: _propTypes.default.instanceOf(Object).isRequired,
  isMobile: _propTypes.default.bool,
  theme: _propTypes.default.string,
  locale: _propTypes.default.string,
  gaIdExperimentValue: _propTypes.default.number,
  isComboSavingsTagEnabled: _propTypes.default.bool,
  savingsAmount: _propTypes.default.number,
  selectRoomLabel: _propTypes.default.string,
  withSelectRoom: _propTypes.default.bool,
  isHotel: _propTypes.default.bool,
  baseRate: _propTypes.default.instanceOf(Object).isRequired,
  isHotelCrossSellCard: _propTypes.default.bool
};
exports.PriceInfoPropTypes = PriceInfoPropTypes;
var PriceInfoDefaultProps = {
  discountText: null,
  strikeThrough: null,
  priceText: null,
  perGuestText: null,
  snapPriceText: null,
  theme: _constant.DEFAULT_THEME,
  isMobile: false,
  locale: 'en-gb',
  isHotel: false
};
exports.PriceInfoDefaultProps = PriceInfoDefaultProps;
var PriceDetailsPropTypes = {
  salesTag: _propTypes.default.string,
  bigPointPromo: _propTypes.default.string,
  setPromoFocused: _propTypes.default.func,
  discountText: _propTypes.default.string,
  strikeThrough: _propTypes.default.instanceOf(Object),
  price: _propTypes.default.instanceOf(Object).isRequired,
  priceText: _propTypes.default.string,
  perGuestText: _propTypes.default.string,
  snapPriceText: _propTypes.default.string,
  totalPrice: _propTypes.default.instanceOf(Object).isRequired,
  promoTag: _propTypes.default.string,
  facilities: _propTypes.default.arrayOf(_propTypes.default.string),
  theme: _propTypes.default.string,
  locale: _propTypes.default.string,
  lowInventoryAlert: _propTypes.default.string,
  fomoMessage: _propTypes.default.string,
  isCarouselCard: _propTypes.default.bool,
  discountType: _propTypes.default.string,
  gaIdExperimentValue: _propTypes.default.number,
  isComboSavingsTagEnabled: _propTypes.default.bool,
  savingsAmount: _propTypes.default.number,
  selectRoomLabel: _propTypes.default.string,
  withSelectRoom: _propTypes.default.bool,
  accessible: _propTypes.default.bool,
  baseRate: _propTypes.default.instanceOf(Object).isRequired,
  isHotelCrossSellCard: _propTypes.default.bool
};
exports.PriceDetailsPropTypes = PriceDetailsPropTypes;
var PriceDetailsDefaultProps = {
  salesTag: null,
  bigPointPromo: null,
  discountText: null,
  strikeThrough: null,
  priceText: null,
  perGuestText: null,
  snapPriceText: null,
  promoTag: null,
  theme: _constant.DEFAULT_THEME,
  facilities: [],
  locale: 'en-gb',
  lowInventoryAlert: null,
  fomoMessage: null,
  isCarouselCard: false,
  discountType: null,
  accessible: null,
  isHotelCrossSellCard: false
};
exports.PriceDetailsDefaultProps = PriceDetailsDefaultProps;